/**
 * SectionHeadline + SectionEyebrow — the section heading shared by the
 * Security Center sub-pages and Baseline Compliance.
 *
 * Carbon headings (DESIGN.md "Typography"): `page` is the 1.25rem/400
 * Heading ("What to close this week"), `card` the 14px/600 Body Emphasis of a
 * tile title. Upright (DESIGN.md "The Upright Rule"): an <em> in the children
 * is reset to font-style normal at 400.
 *
 * SectionEyebrow renders nothing (the No-Kicker Rule). It stays exported so
 * its call sites keep compiling until Wave 2 removes them.
 */

import clsx from 'clsx'
import type { ReactNode } from 'react'

export function SectionEyebrow(_props: { text: string }) {
  return null
}

export function SectionHeadline({
  children,
  level = 'page',
}: {
  children: ReactNode
  level?: 'page' | 'card'
}) {
  return (
    <h2
      className={clsx(
        'm-0 text-text-primary [&_em]:font-normal [&_em]:[font-style:normal]',
        level === 'card' ? 'text-body font-semibold leading-[1.29]' : 'text-heading font-normal',
      )}
    >
      {children}
    </h2>
  )
}
